import update from 'immutability-helper';
// eslint-disable-next-line import/no-cycle
import {
  MARAPHON_TASK_PROGRESS,
  MARAPHON_TASK_SUCCESS,
  MARAPHON_TASK_FAILED,
  MARAPHON_TASK_GET_LIST_PROGRESS,
  MARAPHON_TASK_GET_LIST_SUCCESS,
  MARAPHON_TASK_GET_LIST_FAILED,
  MARAPHON_TASK_FORM_SUBMIT_PROGRESS,
  MARAPHON_TASK_FORM_SUBMIT_SUCCESS,
  MARAPHON_TASK_FORM_SUBMIT_FAILED,
  MARAPHON_TASK_GET_MATERIAL_PROGRESS,
  MARAPHON_TASK_GET_MATERIAL_SUCCESS,
  MARAPHON_TASK_GET_MATERIAL_FAILED,
  MARAPHON_TASK_CLEAR_STATE,
  MARAPHON_TASK_CLEAR_FLASH_MESSAGE,
} from '../actions/maraphonTaskAction';

const initialState = {
  loadListStatus: '', // progress/success/failed
  loadActiveStatus: '', // progress/success/failed
  submitStatus: '', // progress/success/failed
  asyncStatus: '', // progress/success/failed
  list: [],
  pagination: {},
  active: {},
  asyncData: {},
  flash: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MARAPHON_TASK_GET_LIST_PROGRESS: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: MARAPHON_TASK_PROGRESS },
      });
    }
    case MARAPHON_TASK_GET_LIST_SUCCESS: {
      return update(state, {
        list: { $set: action.payload.list },
        pagination: { $set: action.payload.pagination },
        loadListStatus: { $set: MARAPHON_TASK_SUCCESS },
      });
    }
    case MARAPHON_TASK_GET_LIST_FAILED: {
      return update(state, {
        list: { $set: [] },
        pagination: { $set: {} },
        loadListStatus: { $set: MARAPHON_TASK_FAILED },
      });
    }
    case MARAPHON_TASK_FORM_SUBMIT_PROGRESS: {
      return update(state, { submitStatus: { $set: MARAPHON_TASK_PROGRESS } });
    }
    case MARAPHON_TASK_FORM_SUBMIT_SUCCESS: {
      return update(state, {
        flash: { $set: action.payload },
        submitStatus: { $set: MARAPHON_TASK_SUCCESS },
      });
    }
    case MARAPHON_TASK_FORM_SUBMIT_FAILED: {
      return update(state, { submitStatus: { $set: MARAPHON_TASK_FAILED } });
    }
    case MARAPHON_TASK_GET_MATERIAL_PROGRESS: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: MARAPHON_TASK_PROGRESS },
      });
    }
    case MARAPHON_TASK_GET_MATERIAL_SUCCESS: {
      return update(state, {
        active: { $set: action.payload.task },
        loadActiveStatus: { $set: MARAPHON_TASK_SUCCESS },
      });
    }
    case MARAPHON_TASK_GET_MATERIAL_FAILED: {
      return update(state, {
        active: { $set: {} },
        loadActiveStatus: { $set: MARAPHON_TASK_FAILED },
      });
    }
    case MARAPHON_TASK_CLEAR_STATE: {
      return update(state, {
        loadListStatus: { $set: '' },
        loadActiveStatus: { $set: '' },
        submitStatus: { $set: '' },
        asyncStatus: { $set: '' },
        list: { $set: [] },
        pagination: { $set: {} },
        active: { $set: {} },
        asyncData: { $set: {} },
      });
    }
    case MARAPHON_TASK_CLEAR_FLASH_MESSAGE: {
      return update(state, {
        flash: { $set: '' },
      });
    }
    default:
      return state;
  }
}
